/* Selène : ajout rapide au panier depuis les cartes + animation vers l'icône du panier */
(function(){
  function bump(link,n){
    var b=link.querySelector('.count');
    if(!b){b=document.createElement('span');b.className='count';link.appendChild(b);}
    b.textContent=n;
    link.classList.remove('bump');void link.offsetWidth;link.classList.add('bump');
  }
  function voler(depart,cible,src,fin){
    var reduit=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ico=cible.querySelector('svg')||cible;
    var a=depart.getBoundingClientRect(), z=ico.getBoundingClientRect();
    if(reduit||!document.body.animate||!z.width){fin();return;}
    var t=54, x0=a.left+a.width/2-t/2, y0=a.top+a.height/2-t/2;
    var dx=z.left+z.width/2-t/2-x0, dy=z.top+z.height/2-t/2-y0;
    var ext=document.createElement('div'), p=document.createElement('div');
    ext.className='vol-ext'; p.className='vol-pastille';
    ext.style.left=x0+'px'; ext.style.top=y0+'px';
    if(src)p.style.backgroundImage='url("'+src+'")';
    ext.appendChild(p); document.body.appendChild(ext);
    var d=Math.min(900,Math.max(560,Math.hypot(dx,dy)*.9)), fini=false;
    function terminer(){if(fini)return;fini=true;ext.remove();fin();}
    ext.animate([{transform:'translateX(0)'},{transform:'translateX('+dx+'px)'}],{duration:d,easing:'cubic-bezier(.35,0,.65,1)',fill:'forwards'});
    p.animate([
      {transform:'translateY(0) scale(.6)',opacity:0},
      {transform:'translateY(-26px) scale(1)',opacity:1,offset:.18},
      {transform:'translateY('+dy+'px) scale(.28)',opacity:.85}
    ],{duration:d,easing:'cubic-bezier(.55,0,.85,.4)',fill:'forwards'}).onfinish=terminer;
    setTimeout(terminer,d+400);
  }
  window.seleneVoler=voler;

  document.addEventListener('click',function(e){
    var btn=e.target.closest('button[data-ajout]');
    if(!btn||btn.disabled)return;
    e.preventDefault();
    var txt=btn.textContent;
    btn.disabled=true; btn.textContent='Ajout…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+btn.dataset.ajout,quantity:1}]})})
      .then(function(r){if(!r.ok)throw r;return fetch('/cart.js',{headers:{'Accept':'application/json'}});})
      .then(function(r){return r.json();})
      .then(function(c){
        var link=document.querySelector('.cartlink');
        var li=btn.closest('li'), im=li&&li.querySelector('img');
        btn.textContent='Ajouté ✓';
        if(link)voler(btn,link,im?(im.currentSrc||im.src):'',function(){bump(link,c.item_count);});
        setTimeout(function(){btn.textContent=txt;btn.disabled=false;},1600);
      })
      .catch(function(){btn.textContent='Réessayer';btn.disabled=false;});
  });
})();
